import { html, View } from 'rune-ts';
import { Typo } from '../Typo/Typo';
import klass from './Color.module.scss';

const COLOR = {
  black: klass.black,
  white: klass.white,
  primary: klass.primary,
  secondary: klass.secondary,
  tertiary: klass.tertiary,
  success: klass.success,
  error: klass.error,
  accent: klass.accent,
  gray_80: klass.gray_80,
  gray_50: klass.gray_50,
  gray_20: klass.gray_20,
  gray_10: klass.gray_10,
  gray_5: klass.gray_5,
  gray_2_5: klass.gray_2_5,
};

export interface ColorData {
  color: keyof typeof COLOR;
}

export class Color extends View<ColorData> {
  static colors = COLOR;

  override template() {
    return html`<div class="${klass.color} ${Color.colors[this.data.color]}">
      ${new Typo({ text: this.data.color }, { typo: 'h1' })}
    </div> `;
  }
}
